import { useContext } from 'react';
import { GlobalContext } from '../../store/GlobalProvider';

import {
  SET_ACTIVE_BUSINESS_ID,
  SET_ACTIVE_SERVICE,
  SET_ACTIVE_SERVICE_ID,
  SET_ASSOCIATED_BUSINESSES,
  SET_ERROR,
  SET_LOADING,
  SET_OPEN_RIGHT_DETAILS_PANEL,
  SET_PROFILE_FORM_PANEL,
  SET_RIDE_INFO,
  SET_SERVICES,
  SET_TAB_STATE,
  SET_TENANT_SETTINGS,
  SET_TOAST
} from '../../store/actionTypes';

const useGlobalContext = () => {
  const [state, dispatch] = useContext(GlobalContext);

  const setActiveBusinessId = id => {
    dispatch({ type: SET_ACTIVE_BUSINESS_ID, payload: id });
  };

  const setActiveService = activeService => {
    dispatch({ type: SET_ACTIVE_SERVICE, payload: activeService });
  };

  const setActiveServiceId = id => {
    dispatch({ type: SET_ACTIVE_SERVICE_ID, payload: id });
  };

  const setAssociatedBusinesses = associatedBusinesses => {
    dispatch({
      type: SET_ASSOCIATED_BUSINESSES,
      payload: associatedBusinesses,
    });
  };

  const setError = e => {
    if (e && e.response) {
      const data = e.response.data;
      const status = e.response.status;
      const text = e.response.responseText;

      let erroredField;
      let erroredFieldErrorMessage;
      let errorMessage;
      const genericMessage = 'Sorry, something went wrong, please try again soon';
      let responseData = {};
      let message;

      if (status >= 400 && status < 500) {
        if (data && data.non_field_errors) {
          message = data.non_field_errors;
        } else if (text || data) {
          if (data) {
            responseData = data;
          } else if (text) {
            responseData = JSON.parse(text);
          }
          if (responseData.non_field_errors) {
            message = responseData.non_field_errors[0];
          } else if (responseData.message) {
            message = responseData.message;
          } else {
            // Display first field-based error message in a pop-up dialog
            erroredField = Object.keys(responseData)[0];
            erroredFieldErrorMessage = responseData[erroredField];
            erroredField = erroredField.replace(/_/g, ' ');
            erroredField = erroredField.replace(/\d/g, '');
            errorMessage = 'Sorry, invalid ' + erroredField + ': ' + erroredFieldErrorMessage;
            message = errorMessage;
          }
        } else {
          message = genericMessage;
        }
      } else {
        message = genericMessage;
      }
      dispatch({
        type: SET_ERROR,
        payload: { hasError: true, errorMessage: message },
      });
    } else {
      dispatch({
        type: SET_ERROR,
        payload: { hasError: false, errorMessage: '' },
      });
    }
  };

  const setLoading = bool => {
    dispatch({ type: SET_LOADING, payload: bool });
  };

  const setOpenRightDetailsPanel = isOpen => {
    dispatch({ type: SET_OPEN_RIGHT_DETAILS_PANEL, payload: isOpen });
  };

  const setProfileFormPanel = (type, data) => {
    dispatch({
      type: SET_PROFILE_FORM_PANEL,
      payload: { type: type, data: data ? data : null },
    });
  };

  const setRideInfo = rideInfo => {
    dispatch({ type: SET_RIDE_INFO, payload: rideInfo });
  };

  const setServices = services => {
    dispatch({ type: SET_SERVICES, payload: services });
  };

  const setTabState = tabState => {
    dispatch({ type: SET_TAB_STATE, payload: tabState });
  };

  const setTenantSettings = settings => {
    dispatch({ type: SET_TENANT_SETTINGS, payload: settings });
  };

  const setToastState = toast => {
    dispatch({ type: SET_TOAST, payload: toast });
  };

  return {
    state,
    setAssociatedBusinesses,
    setActiveBusinessId,
    setActiveService,
    setActiveServiceId,
    setError,
    setLoading,
    setOpenRightDetailsPanel,
    setProfileFormPanel,
    setRideInfo,
    setServices,
    setTabState,
    setTenantSettings,
    setToastState
  };
};

export default useGlobalContext;
